// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  apiGatewayConfig: {
    apiGatewayUrl: 'https://api-gateway.drcedirect.com/',
    apiGatewayCloudUrl: 'https://api-gateway-cloud.drcedirect.com',
    client: 'all',
    deployment: 'production',
    version: 'v0',
    //TODO: update this link?
    lambdaServiceUrl: 'https://eca-insight-status-api-prod.team-s.drcedirect.com'
  },
  portalUrl: 'https://www.drcedirect.com/all/eca-portal-v2-ui',
  portalHeaderLibUrl: 'https://www.drcedirect.com/eca-portal-header-lib/latest/eca-portal-header-lib.js',
  production: false,
  securityServiceUrl: 'https://api-gateway.drcedirect.com/eca-security-service/all-production-v0/v0/'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
